export enum columnsTypes {
  FETCH_COLUMNS_REQUEST = "FETCH_COLUMNS_REQUEST",
  FETCH_COLUMNS_SUCCESS = "FETCH_COLUMNS_SUCCESS",
  FETCH_COLUMNS_FAILURE = "FETCH_COLUMNS_FAILURE",
}